import { Action, ActionReducer } from '@ngrx/store';
import { ToolIdAction, ToolIdActionType } from '../../actionstypes/selected-id/tool-id.actiontype';

const initialState = -1;

const toolIdReducer = (state = initialState, action: ToolIdActionType): number => {
  switch (action.type) {
    case ToolIdAction.Set:
      return action.payload;

    case ToolIdAction.Reset:
      return -1;

    case ToolIdAction.Sync:
      if (state === -1) {
        return state;
      }

      if (!action.payload.includes(state)) {
        return -1;
      }

      return state;

    default:
      return state;
  }
};

export default toolIdReducer as ActionReducer<number, Action<string>>;
